export const NEW_OFERTA_LINK = 'https://zvuk-b2b.com/oferta';
export const NEW_POPULAR_OFERTA_LINK = 'https://zvuk-b2b.com/oferta-popular';
